import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Star, Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("najm_admin_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen carbon-bg flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-[#121214] border border-[#28282D] rounded-2xl p-8">
        <div className="flex items-center gap-2 justify-center mb-8">
          <span className="w-10 h-10 rounded-lg bg-yellow-400 flex items-center justify-center rotate-3">
            <Star className="w-6 h-6 text-black" fill="currentColor" />
          </span>
          <span className="font-display font-bold text-2xl text-white">
            بنشر متنقل <span className="text-yellow-400">نجم الإطارات</span>
          </span>
        </div>
        <h1 className="font-display font-bold text-lg text-white text-center mb-6">لوحة التحكم</h1>
        <form onSubmit={submit} className="space-y-4">
          <input
            data-testid="admin-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="البريد الإلكتروني"
            dir="ltr"
            className="w-full bg-[#0A0A0A] border border-[#28282D] rounded-lg px-4 py-3 text-sm text-white text-left placeholder:text-zinc-600 focus:border-yellow-400 outline-none transition-colors"
            required
          />
          <input
            data-testid="admin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="كلمة المرور"
            className="w-full bg-[#0A0A0A] border border-[#28282D] rounded-lg px-4 py-3 text-sm text-white placeholder:text-zinc-600 focus:border-yellow-400 outline-none transition-colors"
            required
          />
          {error && (
            <div data-testid="admin-login-error" className="text-red-400 text-sm bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <button
            data-testid="admin-login-btn"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-yellow-400 text-black font-bold py-3 rounded-full hover:bg-yellow-300 transition-colors disabled:opacity-50"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            {loading ? "جارٍ الدخول..." : "دخول"}
          </button>
        </form>
      </div>
    </div>
  );
}
